export default __webpack_public_path__ + "static/iqnet-264c9e7b39af24bac9d3c21fa2340342.png";